const OrbitLoader = () => (
  <div className="flex flex-col items-center justify-center space-y-4 m-auto">
    <div className="relative h-12 w-12">
      <div className="absolute inset-0 border-4 border-indigo-100 rounded-full"></div>
      <div className="absolute inset-0 border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
    </div>
    <p className="text-sm font-medium text-slate-500 animate-pulse">
      Loading...
    </p>
  </div>
);

export default OrbitLoader;
